import { Mentor } from '../../../mocks/mentors';

interface Props {
  mentor: Mentor;
}

const VideoIntro = ({ mentor }: Props) => (
  <div className="rounded-2xl overflow-hidden border border-slate-100 bg-white">
    <div className="relative">
      <img
        src="/assets/readdy/mentorplatform2026-320x180-landscape-08ba2b55.jpg"
        alt={`${mentor.name} 導師介紹`}
        className="w-full h-40 object-cover object-top"
      />
      <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
        <div className="w-12 h-12 flex items-center justify-center bg-violet-600/80 rounded-full">
          <i className="ri-play-fill text-white text-xl" />
        </div>
      </div>
      <div className="absolute bottom-2 left-3 flex items-center gap-1.5">
        <span className="bg-black/50 text-white text-xs font-medium px-2 py-0.5 rounded-full backdrop-blur-sm">
          導師介紹影片
        </span>
      </div>
    </div>
    <div className="p-3">
      <p className="text-slate-500 text-xs leading-relaxed text-center">
        <i className="ri-play-circle-line mr-1 text-violet-500" />
        了解 {mentor.name} 如何協助 {mentor.sessions}+ 位學員進入頂尖外商
      </p>
    </div>
  </div>
);

export default VideoIntro;
